// extracted by mini-css-extract-plugin
export default {"V2Confirm":"V2Confirm--WMNyf","V2ConfirmNoFooter":"V2ConfirmNoFooter--DaARL","markerAnimationScale":"markerAnimationScale--XBlsf"};